import React, { useRef } from "react";
import useOutsideClick from "../../../hooks/useOutsideClick";
import Icon from "../Icon";
import Modal from "./Modal";

interface DataModalProps {
  title?: string;
  close: () => void;
  footerContent?: React.ReactNode;
  width?: string;
  disableOutsideClose?: boolean;
  className?: string;
}

const DataModal: React.FC<DataModalProps> = ({
  title,
  close,
  children,
  footerContent,
  width = "w-content",
  disableOutsideClose,
  className,
}) => {
  const modalRef = useRef(null);
  useOutsideClick(modalRef, disableOutsideClose ? () => {} : close);

  return (
    <Modal
      className={`h-content rounded-lg m-2 shadow-lg text-text ${width}`}
      center={false}
    >
      <section ref={modalRef}>
        {title && (
          <header className="flex items-center justify-between w-full p-4 text-2xl font-medium bg-gray-200 rounded-t-lg">
            <span className="flex-grow truncate">{title}</span>
            <button className="focus:outline-none" onClick={close}>
              <Icon>close</Icon>
            </button>
          </header>
        )}
        <section className={`p-4 bg-white ${className}`}>{children}</section>
        {footerContent && (
          <footer className="p-2 bg-white border-t rounded-b-lg border-accent">
            {footerContent}
          </footer>
        )}
      </section>
    </Modal>
  );
};

export default DataModal;
